import { API_BASE_URL as API_URL } from '../config';

export async function submitPublicContact({ type, name, email, company, message }) {
  const payload = {
    type,
    name,
    email,
    company: company || null,
    message,
  };

  const response = await fetch(`${API_URL}/api/public/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let errorDetail = 'Failed to send message';
    try {
      const error = await response.json();
      if (error && error.detail) {
        errorDetail = error.detail;
      }
    } catch {
      // ignore JSON parse errors and use default message
    }
    throw new Error(errorDetail);
  }

  return response.json();
}

